import { styled } from '@/stitches.config';
import { Box, Button, Form, FormField } from '@base-app';
import { ReactComponent as InfoIcon } from '@assets/icons/info-outlined.svg';

export const FormStyled = styled(Form, { display: 'flex', flexWrap: 'wrap' });

export const FormFieldStyled = styled(FormField, {
  flexBasis: '100%',
  '@sm': {
    flexBasis: '50%',
  },
  marginBottom: 0,
});

export const ButtonStyled = styled(Button, {
  ml: '$4',
  flexGrow: '1',
  '@sm': {
    flexGrow: 'auto',
  },
});

export const StyledInfoIcon = styled(InfoIcon, {
  color: '$darkBlue200',
  marginLeft: '$1',
  width: '$4',
});

export const StyledContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  marginTop: '$9',
  width: '100%',
});

export const StyledItemContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
});

export const StyledLabelContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
});
